import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import TileBadge from '../../../../components/shared/badge'
import TileRentalBadge from '../../../../components/shared/rental-badge'
import TileOverlay from '../../../../components/carousel/tile/overlay'
import CarouselImgix from '../../../../components/imgix/carousel-imgix'
import { dataLayerProductClick } from '../../../../lib/analytics/datalayer'
import { getTileRecipe } from '../../../../components/imgix/recipes'
import { COMPONENT_NAME_SEARCH } from '../../../../lib/analytics/custom-dimensions'
import { useIsAuthenticated } from '../../../../hooks/use-is-authenticated'
import styles from './search-tile.css'

/**
 * A tile component for displaying search result items
 */
const SearchTile = ({
  tile,
  index,
  listTitle,
  isOnMyList,
  addToMyList
}) => {
  const isAuthenticated = useIsAuthenticated()
  const {
    image, badge, contentItem
  } = tile
  const { isRental, path, __typename: type } = contentItem

  const tileRecipe = getTileRecipe(type === 'Title' ? 'PORTRAIT' : 'LANDSCAPE')

  const [isMouseHover, setIsMouseHover] = useState(false)

  return (
    <div>
      <div
        className={styles.tile}
        onMouseEnter={() => {
          setIsMouseHover(true)
        }}
        onMouseLeave={() => {
          setIsMouseHover(false)
        }}
      >
        {badge ? (
          <TileBadge title={badge} isRental={isRental} />
        ) : null}

        <Link
          to={path}
          onClick={() => dataLayerProductClick(contentItem, index, listTitle, window.location.pathname)}
          className={styles.imgWrapper}
        >
          <CarouselImgix src={image.uri} recipe={tileRecipe} />

          {isRental && (
            <TileRentalBadge />
          )}

          <TileOverlay
            tileType={type}
            tile={tile}
            isAuthenticated={isAuthenticated}
            isOnMyList={isOnMyList}
            addToMyList={addToMyList}
            display={isMouseHover}
            isRental={isRental}
            renderedInComponent={COMPONENT_NAME_SEARCH}
          />
        </Link>
      </div>
    </div>
  )
}

SearchTile.propTypes = {
  tile: PropTypes.oneOfType([PropTypes.object]).isRequired,
  index: PropTypes.number.isRequired,
  listTitle: PropTypes.string.isRequired,
  isOnMyList: PropTypes.bool.isRequired,
  addToMyList: PropTypes.func
}

export default SearchTile
